import {enUS, enAU, enNZ, enCA, enGB, frCA, es, arSA, ptBR, Locale} from "date-fns/locale"

import {ValidLocale} from "../../src/Locales"

const locales: Record<ValidLocale, Locale> = {
	"en-US": enUS,
	"en-AU": enAU,
	"en-NZ": enNZ,
	"en-CA": enCA,
	"en-GB": enGB,
	"fr-CA": frCA,
	"es-US": es,
	"es-MX": es,
	"ar-AE": arSA,
	"en-AE": enUS,
	"pt-BR": ptBR,
}

export {locales}
